import { Box, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Carousel from "react-material-ui-carousel";
import { Link } from "react-router-dom";
import { carouselButton, carouselContainer, carouselImage, carouselTitle, carouselWrapper } from "../../styles/carouselStyles";

const CarouselGallery = ({ images, titles = [], links = [] }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  if (!images || images.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          {t("image.noImagesAvailable")}
        </Typography>
      </Box>
    );
  }

  const hasMultiple = images.length > 1;
  const hasTitles = titles.some(Boolean);
  const showNav = hasMultiple;
  const useCarousel = hasMultiple || hasTitles;

  return (
    <Box sx={carouselWrapper(theme)}>
      {useCarousel ? (
        <Carousel
          navButtonsAlwaysVisible={showNav}
          navButtonsAlwaysInvisible={!showNav}
          indicators={false}
          autoPlay={false}
          swipe
          stopAutoPlayOnHover
          animation="slide"
          navButtonsProps={{
            style: carouselButton(theme),
          }}
        >
          {images.map((image, index) => {
            const title = titles[index] || "";
            const altText = title ? t("image.imageAlt", { title }) : t("image.image", { index: index + 1 });
            const link = links[index];

            const ImageContent = (
              <>
                <Tooltip title={title} arrow>
                  <Box component="img" src={image} alt={altText} sx={carouselImage(theme, isSmallScreen)} />
                </Tooltip>
                {title && (
                  <Typography variant="h6" sx={carouselTitle(theme)}>
                    {title}
                  </Typography>
                )}
              </>
            );

            return (
              <Box key={index} sx={carouselContainer(theme)}>
                {link ? (
                  <Link
                    to={link}
                    style={{
                      textDecoration: "none",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {ImageContent}
                  </Link>
                ) : (
                  ImageContent
                )}
              </Box>
            );
          })}
        </Carousel>
      ) : (
        <Box sx={carouselContainer(theme)}>
          <Box component="img" src={images[0]} alt={t("image.image", { index: 1 })} sx={carouselImage(theme, isSmallScreen)} />
        </Box>
      )}
    </Box>
  );
};

export default CarouselGallery;
